import multiguard from 'vue-router-multiguard';

import { checkAuth } from '@/router/_auth';
import { checkActives } from '@/router/_actives';

export default [{
	path: '/forms',
	name: 'forms',
	redirect: 'forms/list',
	meta: {
		menu: true,
		title: 'Formlar',
		layout: 'default',
		requiresAuth: true,
	},
	beforeEnter: multiguard([checkAuth]),
	component: () => import(/* webpackChunkName: "forms" */ '../views/forms/Forms.vue'),
	children: [
		{
			path: 'list',
			name: 'formlist',
			meta: {
				title: 'Liste',
				layout: 'default',
			},
			component: () => import(/* webpackChunkName: "forms" */ '../views/forms/List.vue')
		},
		{
			path: 'new',
			name: 'newform',
			meta: {
				title: 'Yeni Form',
				layout: 'default',
			},
			component: () => import(/* webpackChunkName: "forms" */ '../views/forms/New.vue')
		}
	]
}, {
	path: '/form',
	name: 'form',
	redirect: 'form/:company/:form/detail',
	meta: {
		menu: false,
		title: 'Form',
		layout: 'default',
		requiresAuth: true,
	},
	beforeEnter: multiguard([checkAuth, checkActives]),
	component: () => import(/* webpackChunkName: "form" */ '../views/form/Form.vue'),
	children: [
		{
			path: ':company/:form/detail',
			name: 'formdetail',
			meta: {
				title: 'Detay',
				layout: 'default',
			},
			component: () => import(/* webpackChunkName: "form" */ '../views/form/Detail.vue')
		},
		{
			path: ':company/:form/fields',
			name: 'formfields',
			meta: {
				title: 'Fields',
				layout: 'default',
			},
			component: () => import(/* webpackChunkName: "form" */ '../views/form/Fields.vue')
		},
		{
			path: ':company/:form/smtp',
			name: 'formsmtp',
			meta: {
				title: 'SMTP',
				layout: 'default',
			},
			component: () => import(/* webpackChunkName: "form" */ '../views/form/Smtp.vue')
		}
	]
}]